import React from 'react';
const rows: {
  problem: string;
  cost: string;
}[] = [{
  problem: 'Formals that run 50 minutes',
  cost: 'The 30 minutes you never get back — usually your golden hour and the cocktail-hour candids'
}, {
  problem: 'Improvising couple portraits after five poses',
  cost: 'Portraits cut to eight minutes. The gallery shows it.'
}, {
  problem: 'Not knowing what to cut when the day runs late',
  cost: 'The wrong thing gets cut — and it’s always the part that fills the album'
}, {
  problem: 'Googling poses in the bathroom, phone in your hand',
  cost: 'The couple’s trust — the thing they’re actually paying you for'
}, {
  problem: 'One review that says “a bit disorganized”',
  cost: 'In a referral town, the two or three bookings that never inquire'
}];
export function CostOfInaction() {
  return <section className="w-full bg-ivory py-16 sm:py-24" data-id="element-101" data-mp="3nketka2o40pi">
      <div className="mx-auto max-w-4xl px-5" data-id="element-102" data-mp="3smnovd30jeus">
        <h2 className="text-center font-serif text-3xl sm:text-5xl text-ink" data-id="element-103" data-mp="3sj87u4ps3vqq">
          What does winging it actually cost you?
        </h2>
        <div className="rule-gold mx-auto mt-8 w-32" aria-hidden="true" data-id="element-104" data-mp="39h3ofr0egrt3" />

        <div className="mt-12 overflow-hidden border border-gold-soft bg-white" data-id="element-105" data-mp="34ia71nhzsgnn">
          <div className="grid grid-cols-2" data-id="element-106" data-mp="34k3j5ibdjt31">
            <div className="border-b border-r border-gold-soft px-4 py-3.5 text-[10px] uppercase tracking-[0.16em] text-ink-muted sm:px-6 sm:py-4 sm:text-[11px] sm:tracking-[0.2em]" data-id="element-107" data-mp="30hgj4u4jv1ur">
              Without the system
            </div>
            <div className="border-b border-gold-soft bg-blush-soft px-4 py-3.5 text-[10px] uppercase tracking-[0.16em] text-blush-deep sm:px-6 sm:py-4 sm:text-[11px] sm:tracking-[0.2em]" data-id="element-108" data-mp="3s8mpvterzxt0">
              The real cost
            </div>
          </div>

          {rows.map((row, index) => <div key={row.problem} className={`grid grid-cols-2 ${index > 0 ? 'border-t border-gold-soft/70' : ''}`} data-id="element-109" data-mp="jtm6dntlpxgw" data-mpi={index}>
              <p className="border-r border-gold-soft/70 px-4 py-4 text-[13px] leading-relaxed text-ink-soft sm:px-6 sm:py-5 sm:text-[15px]" data-id="element-110" data-mp="29ahv7vd4azef">
                {row.problem}
              </p>
              <p className="bg-blush-soft/50 px-4 py-4 text-[13px] font-medium leading-relaxed text-blush-deep sm:px-6 sm:py-5 sm:text-[15px]" data-id="element-111" data-mp="1zibyy9fu1vtf">
                {row.cost}
              </p>
            </div>)}
        </div>

        <p className="mt-12 text-center font-serif text-2xl italic leading-snug sm:text-3xl text-ink" data-id="element-112" data-mp="1qkry31lvu1jc">
          One golden hour you don&rsquo;t lose to formals is worth more than this entire
          system.
        </p>
        <p className="mt-4 text-center text-base text-gold-dark" data-id="element-113" data-mp="1ljm5r4w4wgac">
          Your next Saturday can go completely differently.
        </p>
      </div>
    </section>;
}